import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

const propTypes = {
  fixace: PropTypes.string.isRequired,
  jistina: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  puvodniUver: PropTypes.string.isRequired,
  splatka: PropTypes.string.isRequired,
  ucel: PropTypes.string.isRequired,
  uzavreni: PropTypes.string.isRequired,
};

export default function ExtendedForm(props) {
  const {
    puvodniUver,
    jistina,
    splatka,
    fixace,
    uzavreni,
    ucel,
    onChange,
  } = props;

  return (
    <React.Fragment>
      <TextField
        id='puvodniUver'
        label='Původní úvěr poskytnutý od:'
        value={puvodniUver}
        onChange={onChange('puvodniUver')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <TextField
        id='jistina'
        label='Aktuální výše nesplacené jistiny:'
        value={jistina}
        onChange={onChange('jistina')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <TextField
        id='splatka'
        label='Výše měsíční splátky:'
        value={splatka}
        onChange={onChange('splatka')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <TextField
        id='fixace'
        label='Termín konce fixace úrokové sazby:'
        value={fixace}
        onChange={onChange('fixace')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <TextField
        id='ucel'
        label='Účel původního úvěru:'
        value={ucel}
        onChange={onChange('ucel')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <TextField
        id='uzavreni'
        label='Datum uzavření úvěrové smlouvy'
        value={uzavreni}
        onChange={onChange('uzavreni')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
    </React.Fragment>
  );
}

ExtendedForm.propTypes = propTypes;
